import React from 'react';
import Icon from '../../common/Icons';
import {
  APPOINTMENT_STATUS,
  buildAppointmentListSecondaryLine,
  formatPatientLabel,
  formatSlotRange,
  getAppointmentSlotPillProps,
  getAppointmentStatusPillProps,
  getPatientInitials,
  isAppointmentUpcoming
} from './appointmentListDisplay';

export default function AppointmentListItem({
  item,
  isViewing,
  copy,
  onOpenMenu,
  onRowActivate
}) {
  const patientName = formatPatientLabel(item);
  const secondary = buildAppointmentListSecondaryLine(item, copy);
  const statusPill = getAppointmentStatusPillProps(item.status, copy);
  const slotPill = getAppointmentSlotPillProps(item);
  const upcoming = isAppointmentUpcoming(item);
  const initials = getPatientInitials(patientName);
  const slotLabel = formatSlotRange(item);
  const statusModifier = APPOINTMENT_STATUS[item.status]?.modifier || 'absent';

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onRowActivate?.(item);
    }
  };

  return (
    <li
      className={[
        'hd-rdv-list__item',
        item.status === 'ANNULE' || item.status === 'ABSENT' ? 'is-muted' : '',
        upcoming ? 'is-upcoming' : '',
        isViewing ? 'is-viewing' : ''
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={() => onRowActivate?.(item)}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`${patientName} — ${slotLabel}`}
    >
      <span
        className={`hd-rdv-list__dot hd-rdv-list__dot--${statusModifier}`}
        title={statusPill.label}
        aria-hidden
      />
      <span className="hd-rdv-list__avatar" aria-hidden>
        {initials}
      </span>
      <div className="hd-rdv-list__content">
        <div className="hd-rdv-list__primary">
          <span className="hd-rdv-list__title">{patientName}</span>
          <span className={slotPill.className} title={slotLabel}>
            {slotPill.label}
          </span>
        </div>
        <div className="hd-rdv-list__secondary">
          <span className={statusPill.className}>{statusPill.label}</span>
          {upcoming ? <span className="hd-rdv-upcoming-chip">{copy.UPCOMING_BADGE}</span> : null}
          {secondary ? (
            <span className="hd-rdv-list__sub" title={secondary}>
              {secondary}
            </span>
          ) : null}
        </div>
      </div>
      <button
        type="button"
        className="hd-rdv-list__menu hd-exam-actions-menu__toggle"
        onClick={(event) => {
          event.stopPropagation();
          onOpenMenu(event, item);
        }}
        aria-label={`Actions pour ${patientName}`}
        title="Actions"
      >
        <Icon name="ellipsis-vertical" size={17} />
      </button>
    </li>
  );
}
